"use client";

import { useMemo } from "react";
import Utils from "@/components/shared/utils";
import { useConfig } from "@/lib/providers/ConfigProvider";

export default function useUtils() {
  const config = useConfig();

  return useMemo(
    () => Utils(config),
    [config.apiUrl, config.webUrl, config.secureCookies]
  );
}
